import BottomSheet from '@gorhom/bottom-sheet';
import { useNavigation } from '@react-navigation/native';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BottomSheetFilterProps, BottomSheetFilterValues } from '@/features/account-management/screens/list/BottomSheetFilter';

export const useListNative = ({ status }: { status: { label: string; value: string }[] }) => {
  const navigation = useNavigation();
  const bottomSheetRef = useRef<BottomSheet>(null);
  const { t } = useTranslation('card-account-management');

  const onClose = () => {
    navigation.goBack();
  };

  const [filter, setFilter] = useState<BottomSheetFilterValues>({});
  const filterNumbers = Object.keys(filter)
    .map((key) => filter[key])
    .filter((item) => item).length;

  const bottomSheetFilterProps: BottomSheetFilterProps = {
    title: t('earn-invest::glossary.mobile-filter'),
    bottomSheetRef,
    options: [
      {
        label: t('card-account-management::account-page.text--status'),
        name: 'status',
        options: status,
        singleSelect: true
      }
    ],
    values: filter,
    filteringNumber: filterNumbers,
    onClose,
    onChange: (tempFilters) => {
      setFilter(tempFilters);
    }
  };

  return {
    bottomSheetRef,
    filter,
    bottomSheetFilterProps
  };
};
